import { Nav } from "@/components/landing/Nav";
import { Hero } from "@/components/landing/Hero";
import { BrightspotStory } from "@/components/landing/BrightspotStory";
import { Manifesto } from "@/components/landing/Manifesto";
import { EditorialMarquee } from "@/components/landing/EditorialMarquee";
import { WhyUnique } from "@/components/landing/WhyUnique";
import { Essentials } from "@/components/landing/Essentials";
import { Brands } from "@/components/landing/Brands";
import { BecomeBrightspot } from "@/components/landing/BecomeBrightspot";
import { FaqSection } from "@/components/landing/FaqSection";
import { Footer } from "@/components/landing/Footer";

export default function Landing() {
  return (
    <main data-testid="landing-page" className="relative bg-brand-bg text-brand-bone">
      <Nav />
      <Hero />
      <BrightspotStory />
      <Manifesto />
      <EditorialMarquee />
      <WhyUnique />
      <Essentials />
      <Brands />
      <BecomeBrightspot />
      <FaqSection />
      <Footer />
    </main>
  );
}
